module.exports = __webpack_public_path__ + "img/26_213.3282a21d.png";